import { render, staticRenderFns } from "./PasswordSet.vue?vue&type=template&id=3b271d16&lang=pug&"
import script from "./PasswordSet.vue?vue&type=script&lang=js&"
export * from "./PasswordSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports